import Footer from '@/components/footer/FooterWrapper';
import Layout from '@/components/layout/LayoutWrapper';
import SecondFreeTrial from '@/components/secondFreeTrial';

const SecondFreeTrialPage = () => {
	return (
		<Layout pageName="second_free_trial_offer" title="Calm - Second Free Trial">
			<SecondFreeTrial />
			<Footer />
		</Layout>
	);
};

export { getServerSideProps } from '@/utils/pageGeneration/getServerSideProps';

export default SecondFreeTrialPage;
